import React from 'react'
import InputField from '../InputField'

const MLInputField = ({ formHandler, name, isRequired = true, isLoading = false, defaultValue }) => {
    console.log(defaultValue)
    return (
        <>
            <InputField defaultValue={defaultValue?.name} name={`${name}`} formHandler={formHandler} isLoading={isLoading} isRequired={isRequired} />
            <InputField defaultValue={defaultValue?.nameEN} name={`${name}En`} formHandler={formHandler} lang='En' isLoading={isLoading} isRequired={isRequired} />
        </>
    )
}

export default MLInputField